(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["email-popup"]) return;
  try {
    
  (() => {
    const popup = document.getElementById('BoutiqueEmailPopup');
    if (!popup || typeof popup.showModal !== 'function') return;
    const storageKey = 'nyasias-hair-club-popup-v1';
    const success = popup.querySelector('[data-popup-success]');
    const error = popup.querySelector('[data-popup-error]');
    let previousFocus;
    let suppressed = false;
    try { suppressed = Date.now() < Number(localStorage.getItem(storageKey) || 0); } catch {}
    const remember = (days) => { try { localStorage.setItem(storageKey, String(Date.now() + days * 86400000)); } catch {} };
    const dismiss = () => { remember(success ? 365 : 7); popup.close(); };
    popup.querySelectorAll('.boutique-popup-close, .boutique-popup-dismiss').forEach(button => button.addEventListener('click', dismiss));
    popup.addEventListener('cancel', () => remember(success ? 365 : 7));
    popup.addEventListener('click', event => {
      const box = popup.getBoundingClientRect();
      if (event.target === popup && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dismiss();
    });
    popup.addEventListener('close', () => { if (previousFocus && previousFocus.isConnected) previousFocus.focus(); });
    const open = () => {
      if (popup.open) return;
      previousFocus = document.activeElement;
      popup.showModal();
      if (success) remember(365);
    };
    if (success || error) open();
    else if (!suppressed) {
      if (document.readyState === 'complete') window.setTimeout(open, 500);
      else window.addEventListener('load', () => window.setTimeout(open, 500), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
